/**
 * @file 直播间点赞动效
 * @createDate 2022-06-20
 */

import lvZan from '../assets/lv-zan.png'
import hongXin from '../assets/hong-xin.png'
import huangZan from '../assets/huang-zan.png'
import hongHuo from '../assets/hong-huo.png'
import ziZan from '../assets/zi-zan.png'

/**
 * >=min && <=max
 * @param min
 * @param max
 */

// 取区间随机数
function getRandom (min, max) {
  return min + Math.floor(Math.random() * (max - min + 1))
}
// 定义点赞类
export class ThumbsUpAni {
  imgsList = [];
  context;
  width = 0;
  height = 0;
  scanning = false;
  renderList=[];
  scaleTime = 0.1;// 百分比 总共运行时间的10%时，逐步放大
  position=0; // 图片渲染到第几个
  praiseLast=100; // 阀值
  thumbsStart= 0; //
  thumbsInter=0;
  constructor () {
    this.loadImages()
    const canvas = document.getElementById('thumsCanvas')
    this.context = canvas.getContext('2d')
    this.width = canvas.width
    this.height = canvas.height
  }

  // 按顺序加载点赞图片,如果有下载失败，不显示该图片
  loadImages () {
    const images = [
      // '绿赞 红心 橙赞 橙火  紫赞'
      lvZan,
      hongXin,
      huangZan,
      hongHuo,
      ziZan
    ]
    const promiseAll = []
    images.forEach((src) => {
      const p = new Promise(function (resolve) {
        const img = new Image()
        img.onerror = img.onload = resolve.bind(null, img)
        img.src = src
      })
      promiseAll.push(p)
    })
    Promise.all(promiseAll).then((imgsList) => {
      this.imgsList = imgsList.filter((d) => {
        if (d && d.width > 0) return true
        return false
      })
      if (this.imgsList.length === 0) {
        console.log('error', 'imgsList load all error')
      }
    })
  }

  // 创建渲染对象
  createRender () {
    if (this.imgsList.length === 0) return null
    // const basicScale = [0.6, 0.9, 1.2][getRandom(0, 2)]

    // const getScale = (diffTime) => {
    //   if (diffTime < this.scaleTime) {
    //     return +((diffTime / this.scaleTime).toFixed(2)) * basicScale
    //   } else {
    //     return basicScale
    //   }
    // }
    const context = this.context
    // 随机读取一个图片来渲染
    // const image = this.imgsList[getRandom(0, this.imgsList.length - 1)]
    const image = this.imgsList[this.position]
    const offset = 10
    const basicX = this.width / 1.5 + getRandom(-offset, offset)
    const angle = getRandom(2, 10)
    const ratio = getRandom(10, 25) * ((getRandom(0, 1) ? 1 : -1))
    // diffTime 运行时间/总时常的比值
    const getTranslateX = (diffTime) => {
      // return basicX
      //  用到正弦曲线
      return basicX + ratio * Math.sin(angle * (diffTime - this.scaleTime))
      // return basicX
      // if (diffTime < this.scaleTime) { // 放大期间，不进行摇摆位移
      //   console.log('444')
      //   return basicX
      // } else {
      //   console.log('666')
      //   return basicX + ratio * Math.sin(angle * (diffTime - this.scaleTime))
      // }
    }
    // 底部运行到顶部留下，顶部会淡化隐藏
    const getTranslateY = (diffTime) => {
      return image.height / 2 + (this.height - image.height / 2) * (1 - diffTime)
    }
    // 运行到最后淡出
    const fadeOutStage = getRandom(14, 18) / 100
    // 剩余时间不同,淡出程度不同
    const getAlpha = (diffTime) => {
      const left = 1 - +diffTime
      if (left > fadeOutStage) {
        return 1
      } else {
        return 1 - +((fadeOutStage - left) / fadeOutStage).toFixed(2)
      }
    }

    return (diffTime) => {
      // 差值满了，即结束了 0 ---》 1
      if (diffTime >= 1) return true
      // 保存绘图上下文的设置
      context.save()
      // const scale = getScale(diffTime)
      // const rotate = getRotate();
      const translateX = getTranslateX(diffTime)
      const translateY = getTranslateY(diffTime)
      // 移动位置
      context.translate(translateX, translateY)
      // 屏蔽放大
      // context.scale(scale, scale)
      // context.rotate(rotate * Math.PI / 180);
      // 设置透明度
      context.globalAlpha = getAlpha(diffTime)
      context.drawImage(
        image,
        -image.width / 2, // 绘制位置
        -image.height / 2, // 绘制位置
        image.width / 2, // 绘制宽
        image.height / 2 // 绘制高
      )
      context.restore()
    }
  }

  // 开启实时绘制扫描器 扫描每一次渲染是否完成，及时移除
  scan () {
    // 擦除画布
    this.context.clearRect(0, 0, this.width, this.height)
    this.context.fillStyle = 'rgba(0,0,0,0)'
    this.context.fillRect(0, 0, 100, 240)
    let index = 0
    let length = this.renderList.length
    if (length > 0) {
      requestFrame(this.scan.bind(this))
      this.scanning = true
    } else {
      this.scanning = false
      // 显示canvas元素块
      this.handleCanvasShow('none')
    }
    while (index < length) {
      const child = this.renderList[index]
      if (!child || !child.render || child.render.call(null, (Date.now() - child.timestamp) / child.duration)) {
        // 结束了，删除该动画
        this.renderList.splice(index, 1)
        length--
      } else {
        // continue
        index++
      }
    }
  }

  // 每点赞一次，或者接收别人点赞一次，调用star生成渲染实列
  start () {
    this.position++
    if (this.position === 5) {
      this.position = 0
    }
    const render = this.createRender()
    const duration = getRandom(1500, 3000)
    this.renderList.push({
      render,
      duration,
      timestamp: Date.now()
    })
    // 未开启扫描器，启动扫描器，
    if (!this.scanning) {
      this.scanning = true
      requestFrame(this.scan.bind(this))
      // 隐藏canvas元素块
      this.handleCanvasShow('block')
    }
    return this
  }

  // 保持不扎堆
  thumbsUp (num = 700) {
    // 剩余没绘制的赞和
    if (num <= this.praiseLast) return
    // 500
    this.thumbsStart = this.praiseLast
    // 600
    this.praiseLast = num // 100

    // 100  600
    // 保证diff最大值是500
    if (this.thumbsStart + 500 < num) { this.thumbsStart = num - 500 }
    const diff = this.praiseLast - this.thumbsStart
    let time = 100
    let isFirst = true
    // 定时器执行中返回
    if (this.thumbsInter !== 0) {
      return
    }
    // 新增点赞，定时器还在运行
    this.thumbsInter = setInterval(() => {
      if (this.thumbsStart >= this.praiseLast) {
        clearInterval(this.thumbsInter)
        this.thumbsInter = 0
        return
      }
      // 增加
      this.thumbsStart++
      this.start()
      if (isFirst) {
        isFirst = false
        // 5s内把剩余渲染完
        time = Math.round(5000 / diff)
      }
    }, time)
  }

  // 显示隐藏canvas元素块
  handleCanvasShow (display) {
    const style = document.getElementById('thumsCanvas').style
    if (display === style.display) return false
    style.display = display
  }
}

function requestFrame (cb) {
  // 判断浏览器
  return (
    window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    function (callback) {
      window.setTimeout(callback, 1000 / 60)
    }
  )(cb)
}
